module.exports = __webpack_public_path__ + "img/img6.010e575f.png";